"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAreaJson = exports.Area = exports.AreaUnitTexts = exports.AreaUnits = void 0;
const Quantity_1 = require("./Quantity");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
var AreaUnits;
(function (AreaUnits) {
    AreaUnits["default"] = "m2";
    AreaUnits["mm2"] = "mm2";
    AreaUnits["cm2"] = "cm2";
    AreaUnits["m2"] = "m2";
    AreaUnits["km2"] = "km2";
})(AreaUnits = exports.AreaUnits || (exports.AreaUnits = {}));
exports.AreaUnitTexts = {
    [AreaUnits.default]: 'm²',
    [AreaUnits.mm2]: 'mm²',
    [AreaUnits.cm2]: 'cm²',
    [AreaUnits.m2]: 'm²',
    [AreaUnits.km2]: 'km²',
};
class Area extends Quantity_1.Quantity {
    constructor() {
        super(...arguments);
        this.className = 'Area';
        this.type = this.className;
        this.defaultUnit = 'm2';
        this.unitTexts = exports.AreaUnitTexts;
    }
    static getUnitText(unit) {
        return exports.AreaUnitTexts[unit];
    }
    static fromJson(q) {
        if (!Object.values(AreaUnits).includes(q.Unit)) {
            throw new Error(`Area.fromJson: Unit not supported: ${q.Unit}`);
        }
        return new Area(q);
    }
    static mm2(v) {
        return new Area(v, AreaUnits.mm2);
    }
    static cm2(v) {
        return new Area(v, AreaUnits.cm2);
    }
    static m2(v) {
        return new Area(v, AreaUnits.m2);
    }
    static km2(v) {
        return new Area(v, AreaUnits.km2);
    }
    set mm2(v) {
        this.value = v;
        this.unit = AreaUnits.mm2;
    }
    get mm2() {
        return this.unit === AreaUnits.mm2 ? this.value : this.m2 * 1000000;
    }
    get m2() {
        switch (this.unit) {
            case AreaUnits.m2:
                return this.value;
            case AreaUnits.cm2:
                return this.value / 10000;
            case AreaUnits.mm2:
                return this.value / 1000000;
            case AreaUnits.km2:
                return this.value * 1000000;
        }
        throw new Error(`${this.className}.m2: unknown unit ${this.unit}`);
    }
    set m2(v) {
        this.value = v;
        this.unit = AreaUnits.m2;
    }
    get cm2() {
        return this.unit === AreaUnits.cm2 ? this.value : this.m2 * 10000;
    }
    set cm2(v) {
        this.value = v;
        this.unit = AreaUnits.cm2;
    }
    set km2(v) {
        this.value = v;
        this.unit = AreaUnits.km2;
    }
    get km2() {
        return this.unit === AreaUnits.km2 ? this.value : this.m2 / 1000000;
    }
    clone() {
        return Area.fromJson(this.toJson());
    }
    getValue(unit) {
        switch (unit) {
            case 'default':
            case AreaUnits.m2:
                return this.m2;
            case AreaUnits.mm2:
                return this.mm2;
            case AreaUnits.cm2:
                return this.cm2;
            case AreaUnits.km2:
                return this.km2;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(unit);
        }
    }
}
exports.Area = Area;
Area.units = AreaUnits;
const isAreaJson = (l) => {
    return (0, Quantity_1.isQuantityJson)(l) && (0, echain_shared_ts_utils_1.isValueInEnum)(AreaUnits, l.Unit);
};
exports.isAreaJson = isAreaJson;
//# sourceMappingURL=Area.js.map